import PageHero from "@/components/layout/PageHero";
import SEO from "@/components/layout/SEO";
import LeadMagnet from "@/components/home/LeadMagnet";
import FAQSection from "@/components/home/FAQSection";
import FinalCTA from "@/components/home/FinalCTA";
import { FileText } from "lucide-react";

const GUIDES = [
  { title: "Study in Poland · Starter Guide", body: "A practical overview — universities, costs, documents, visa basics.", status: "Available" },
  { title: "Admission Documents Checklist", body: "By study level and nationality. Apostille, recognition, translations.", status: "Coming soon" },
  { title: "Visa & Application Roadmap", body: "Step-by-step timeline from offer letter to residence card.", status: "Coming soon" },
  { title: "Tuition & Living Costs Guide", body: "Realistic numbers for Warsaw, Kraków, Poznań, Wrocław and more.", status: "Coming soon" },
  { title: "Medicine / Dentistry Entry Guide", body: "Selective admissions, entrance exams, institution-by-institution notes.", status: "Coming soon" },
  { title: "PhD in Poland · Research Path", body: "Supervisor search, doctoral schools, funding and interview prep.", status: "Coming soon" },
];

export default function FreeResources() {
  return (
    <div data-testid="page-free-resources">
      <SEO
        title="Free guides for studying in Poland"
        description="Free downloadable guides for international students applying to Polish universities — including the LanguageCert ESOL B2 Guide with our official discount code."
        path="/free-resources"
      />
      <PageHero
        overline="Free resources"
        title={<>Practical guides for <span className="italic text-[#D7141A]">real decisions</span>.</>}
        subtitle="Written from fifteen years of direct work with Polish higher education. No fluff, no affiliate links — just the answers international students actually need."
      />

      <section className="section-pad pt-0" data-testid="resources-grid">
        <div className="container-sp grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {GUIDES.map((g, i) => (
            <div key={i} className="card-sp h-full flex flex-col" data-testid={`guide-card-${i}`}>
              <FileText className="w-8 h-8 text-[#D7141A]" />
              <h3 className="font-serif text-xl text-[#0D1B2A] mt-5 leading-snug">{g.title}</h3>
              <p className="text-sm text-[#4A5568] mt-2 leading-relaxed flex-1">{g.body}</p>
              <div className="mt-6 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#D7141A]">
                {g.status}
              </div>
            </div>
          ))}
        </div>
      </section>

      <LeadMagnet />
      <FAQSection />
      <FinalCTA />
    </div>
  );
}
